import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/_services/api.service';
import { GlobalService } from 'src/app/_services/global.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { environment } from 'src/environments/environment';
import { interval, Subscription } from 'rxjs';
import {
  isPlaylistBloccata,
  PLAYLIST_FERMA_MINUTI_DEFAULT,
  playlistBloccataMessaggio,
} from '../monitor-playlist-alert.util';

@Component({
  selector: 'app-monitor-edit',
  templateUrl: './monitor-edit.component.html',
  styleUrls: ['./monitor-edit.component.css'],
  providers: [MessageService, ConfirmationService],
})
export class MonitorEditComponent implements OnInit, OnDestroy {
  defaultImage = './assets/img/offline.png';
  action = '';
  struttureList: any[] = [];
  tipimonitorList: any[] = [];
  monitor: any;
  refreshSubscription: Subscription;
  readonly offlineMinuti = 3;
  playlistFermaMinuti = PLAYLIST_FERMA_MINUTI_DEFAULT;
  readonly isPlaylistBloccata = isPlaylistBloccata;
  readonly playlistBloccataMessaggio = playlistBloccataMessaggio;
  screenshotInAttesa = false;
  screenshotDisplayUrl = './assets/img/offline.png';
  screenshotPopupVisible = false;
  screenshotPopupWidth = 0;
  screenshotPopupHeight = 0;
  screenshotThumbWidth = 0;
  screenshotThumbHeight = 0;

  comandiDevice = [
    { label: 'Sveglia CEC', comando: 'CEC_WAKEUP', icon: 'pi pi-sun', style: 'p-button-info' },
    { label: 'Standby CEC', comando: 'CEC_STANDBY', icon: 'pi pi-power-off', style: 'p-button-secondary' },
    { label: 'Reboot device', comando: 'REBOOT', icon: 'pi pi-replay', style: 'p-button-danger' },
  ];

  constructor(
    private apiService: ApiService,
    public globalService: GlobalService,
    private messageService: MessageService,
    private route: ActivatedRoute,
    public router: Router,
    public confirmationService: ConfirmationService
  ) {}

  ngOnInit(): void {
    this.action = this.route.snapshot.paramMap.get('action');
    this.monitor = {
      codice: '',
      modello: '',
      struttura_id: 0,
      descrizione: '',
      note: '',
      tipo: '',
      indirizzo_ip: '',
      nome: '',
    };

    this.apiService.get('mensa/getstrutture', {}).subscribe((data: any) => {
      this.struttureList = data.Result;
      this.struttureList.unshift({ value: 99999, text: 'Sede Centrale' });
    });

    this.apiService.post('kodi/tipimonitor_listall', []).subscribe((data2: any) => {
      this.tipimonitorList = data2.Result;
    });

    if (this.route.snapshot.paramMap.get('id')) {
      this.loadPlaylistAlertSetup();
      this.caricaMonitor();
      this.refreshSubscription = interval(60000).subscribe(() => this.caricaMonitor(false));
    }
  }

  private loadPlaylistAlertSetup(): void {
    this.apiService.post('kodi/monitor_setup_get', {}).subscribe(
      (data: any) => {
        const row = data?.Result?.[0] || data?.Result;
        if (row?.minuti_playlist_ferma != null) {
          this.playlistFermaMinuti = Number(row.minuti_playlist_ferma) || PLAYLIST_FERMA_MINUTI_DEFAULT;
        }
      },
      () => {
        /* usa default */
      }
    );
  }

  ngOnDestroy(): void {
    if (this.refreshSubscription) {
      this.refreshSubscription.unsubscribe();
    }
  }

  caricaMonitor(showToast = false): void {
    const id = this.route.snapshot.paramMap.get('id');
    this.apiService.post('kodi/monitorslistall', { id: id }).subscribe((data2: any) => {
      if (data2.Result && data2.Result[0]) {
        this.monitor = data2.Result[0];
        this.screenshotInAttesa = !!this.monitor.screenshot_richiesto;
        this.updateScreenshotDisplayUrl();
        if (showToast) {
          this.addSingle('info', 'Aggiornato', 'Dati monitor aggiornati');
        }
      }
    });
  }

  salva(): void {
    if (!this.monitor.nome) {
      this.monitor.nome = this.monitor.descrizione || ('monitor-' + this.monitor.indirizzo_ip);
    }
    this.apiService.post('kodi/updatemonitor', this.monitor).subscribe(() => {
      this.addSingle('success', 'Successo', 'Monitor salvato');
      setTimeout(() => {
        this.router.navigate(['/dashboard/monitors']);
      }, 1500);
    });
  }

  delete(): void {
    this.confirmationService.confirm({
      message: 'Attenzione: si conferma la cancellazione?',
      accept: () => {
        this.apiService.post('kodi/deletemonitor', this.monitor).subscribe(() => {
          this.addSingle('success', 'Success', 'Monitor cancellato');
          setTimeout(() => {
            this.router.navigateByUrl('/dashboard/monitors');
          }, 1500);
        });
      },
    });
  }

  richiediScreenshot(): void {
    this.apiService.post('kodi/requestscreenshot', { id: this.monitor.id }).subscribe(() => {
      this.screenshotInAttesa = true;
      this.addSingle(
        'info',
        'Screenshot richiesto',
        'Il device invierà l\'immagine al prossimo segnale (entro ~1 min).'
      );
    });
  }

  inviaComando(comando: string, label: string): void {
    this.confirmationService.confirm({
      message: 'Confermi l\'invio del comando "' + label + '" al device?',
      accept: () => {
        this.apiService
          .post('kodi/senddaemoncommand', { id: this.monitor.id, comando: comando })
          .subscribe(() => {
            this.addSingle('success', 'Comando accodato', label + ' — esecuzione entro ~1 min.');
          });
      },
    });
  }

  vaiAlReport(): void {
    this.router.navigate(['/dashboard/monitors/monitor-report/' + this.monitor.id]);
  }

  hasMonitorIp(): boolean {
    return !!(this.monitor?.indirizzo_ip && String(this.monitor.indirizzo_ip).trim());
  }

  monitorHttpUrl(): string {
    return 'http://' + String(this.monitor.indirizzo_ip).trim() + ':8080';
  }

  monitorLogViewerUrl(): string {
    return 'http://' + String(this.monitor.indirizzo_ip).trim() + ':8088';
  }

  apriMonitorHttp(): void {
    if (!this.hasMonitorIp()) {
      return;
    }
    window.open(this.monitorHttpUrl(), '_blank');
  }

  apriLogViewer(): void {
    if (!this.hasMonitorIp()) {
      return;
    }
    window.open(this.monitorLogViewerUrl(), '_blank');
  }

  qualeAzione(record: any): string {
    if (record && record.stato_colore) {
      return record.stato_colore;
    }
    if (!this.isOnline(record)) {
      return 'Red';
    }
    if (record.azione_corrente === 'Sleep') {
      return 'Black';
    }
    if (record.azione_corrente === 'Play') {
      return 'Green';
    }
    return 'Orange';
  }

  isOnline(record: any): boolean {
    if (!record) {
      return false;
    }
    if (record.online === true || record.online === false) {
      return record.online;
    }
    const last = record.last_daemon_at || record.last_update;
    if (!last) {
      return false;
    }
    return Date.now() - new Date(last).getTime() < this.offlineMinuti * 60000;
  }

  screenshotUrl(): string {
    return this.screenshotDisplayUrl;
  }

  hasScreenshot(): boolean {
    return !!this.monitor?.last_screenshot_url;
  }

  get screenshotPopupDialogStyle(): { [key: string]: string } {
    const padding = 32;
    return {
      width: Math.min(this.screenshotPopupWidth + padding, window.innerWidth * 0.95) + 'px',
      maxWidth: '95vw',
    };
  }

  onScreenshotThumbLoad(img: HTMLImageElement): void {
    this.screenshotThumbWidth = img.offsetWidth;
    this.screenshotThumbHeight = img.offsetHeight;
  }

  apriScreenshotPopup(img: HTMLImageElement): void {
    if (!this.hasScreenshot()) {
      return;
    }
    const width = img.offsetWidth || this.screenshotThumbWidth;
    const height = img.offsetHeight || this.screenshotThumbHeight;
    if (!width || !height) {
      return;
    }
    this.screenshotPopupWidth = width * 2;
    this.screenshotPopupHeight = height * 2;
    this.screenshotPopupVisible = true;
  }

  private updateScreenshotDisplayUrl(): void {
    if (!this.monitor?.last_screenshot_url) {
      this.screenshotDisplayUrl = this.defaultImage;
      return;
    }
    const cacheBust = this.monitor.last_screenshot_at || this.monitor.id || '';
    this.screenshotDisplayUrl =
      this.monitor.last_screenshot_url + '?t=' + encodeURIComponent(String(cacheBust));
  }

  formatDateTime(value: any): string {
    if (!value) {
      return '—';
    }
    const d = new Date(value);
    if (isNaN(d.getTime())) {
      return '—';
    }
    return d.toLocaleString('it-IT');
  }

  addSingle(sev: string, sum: string, det: string): void {
    this.messageService.add({ severity: sev, summary: sum, detail: det });
  }

  onImgError(event: any): void {
    event.target.src = this.defaultImage;
  }
}
